import { useEffect, useState } from 'react';
import { Alignments, classFromProperties, getOptionalProps, getUniqId, Paddings, Sizes } from '../../ui-helpers';
import './state-box.css';

/**
 * State box component.
 * @param {ReactDOM.props} props Component properties
 * @returns Generated component.
 */
const StateBox = (props) => {    // Excluded properties for automatic properties propagation
    const Excluded = ['id', 'label', 'labelStyle', 'onClick', 'inline', 'before', 'checked', 'disabled', 'readOnly', 'alignLeft', 'normal'].concat(Alignments, Paddings, Sizes);

    // Define checked values
    const checkedValue = props?.checked === undefined ? true : props?.checked;

    // Initialize states
    const [ id ] = useState(props?.id ? props.id : getUniqId())
    const [ checked, setChecked ] = useState(props?.value)
    const [ isDisabled, setDisabled ] = useState(props?.disabled !== undefined ? props?.disabled : false);
    const [ isReadOnly, setReadOnly ] = useState(props?.readOnly !== undefined ? props?.readOnly : false);
    
    /**
     * Handles check box click.
     * @param {ClickEvent} evt Click event.
     */
    const handleClick = (evt) => {
        // Check readonly
        if (props?.readOnly) return;

        // Update value
        evt.target.checked = checkedValue;
        evt.target.value = checkedValue;
        props?.onClick?.(evt);
    }

    /**
     * Handles value change from properties.
     */
    useEffect(() => {
        setChecked(props?.value);
        setDisabled(props?.disabled !== undefined ? props?.disabled : false);
        setReadOnly(props?.readOnly !== undefined ? props?.readOnly : false);
    }, [props?.value, props?.disabled, props?.readOnly])    // Render component
    return (
        <div 
            id={id}            className={classFromProperties(
                props,
                'state-box' +
                    (checked ? ' checked' : '') +
                    (isDisabled ? ' disabled' : '') +
                    (isReadOnly ? ' readOnly' : '') +
                    (props?.alignLeft ? ' align-left' : '') +
                    (props?.normal ? ' normal' : ''),
                Alignments,
                Paddings,
                Sizes,
                ['inline', 'before']
            )}
            onClick={handleClick}
            {...getOptionalProps(props, Excluded)}
        >
            {props?.alignLeft ? (
                <>
                    <div className='checkbox-container'>
                        <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                    </div>
                    {props?.label ? <label style={props?.labelStyle}>{props.label}</label> : <></>}
                </>
            ) : (
                <>
                    {props?.label ? <label style={props?.labelStyle}>{props.label}</label> : <></>}
                    <div className='checkbox-container'>
                        <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                    </div>
                </>
            )}
        </div>
    )
}

export default StateBox;